import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import {
    frServices, enServices,
    frServicesPage, enServicesPage,
    frInputs, enInputs,
    frFormInputs, enFormInputs,
    frErrors, enErrors,
    frResponses, enResponses,
    frFooter, enFooter,
    frDocuments, enDocuments,
    frContact, enContact,
    frPagePaymentLink, enPagePaymentLink

} from "./utils/imports/import-translations";

i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: ["fr", "en-US", "de"],
        lng: 'fr',
        interpolation: {
            escapeValue: false
        },
        resources: {
            fr: {
                translation: {
                    services: frServices,
                    errors: frErrors,
                    pageServices: frServicesPage,
                    inputs: frInputs,
                    formInputs: frFormInputs,
                    responses: frResponses,
                    footer: frFooter,
                    documents: frDocuments,
                    contact: frContact,
                    pagePaymentLink: frPagePaymentLink
                }
            },
            en: {
                translation: {
                    services: enServices,
                    errors: enErrors,
                    pageServices: enServicesPage,
                    inputs: enInputs,
                    formInputs: enFormInputs,
                    responses: enResponses,
                    footer: enFooter,
                    documents: enDocuments,
                    contact: enContact,
                    pagePaymentLink: enPagePaymentLink

                }
            }
        }
    });

export default i18n;